import {useDispatch, useSelector} from "react-redux";
import BaseTable, {FieldType} from "../table/BaseTable.tsx";
import {useEffect} from "react";
import {user} from "@/store/modules/user.ts";
import {RootState} from "@/store";


export default function MembersModule() {
    const dispatch = useDispatch<any>()
    const workspaceId = useSelector((state: RootState) => state.workspace.selectedWorkspace.workspaceId)
    const UserState = useSelector((state: RootState) => state.user)
    const refreshPage = () => {
        window.location.reload()
    }
    useEffect(() => {
        dispatch(user.action.readUserByWorkspaceId({workspaceId: workspaceId}))
    }, []);

    const fields: FieldType[] = [
        {label: "Name", key: "userFullName",},
        {label: "Email", key: "userEmail"},
        {label: "Status", key: "userStatus"},
    ]
    return (
        <>
            <div className="margin-top margin-xsmall">
                <div className="margin-bottom margin-small">
                    <div className="spec-header">Members</div>
                    <p className="paragraph">
                        A module is a self-contained unit of code that performs a specific
                        function and can be used in conjunction with other modules to build
                        a larger software system.
                    </p>
                </div>
                <BaseTable title={"Members"} component={""} items={UserState.userByWorkspaceId}
                           refreshPage={refreshPage}
                           showToast={false}
                           fields={fields}/>
            </div>
        </>
    );
}
